import styled from 'styled-components';

const Wrapper = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  overflow: ${({$overflow}) => ($overflow ? 'visible' : 'hidden')};
`;

const Title = styled.span`
  font-size: 18px;
  line-height: 32px;
  font-weight: 600;
  margin: 0 0 4px;
  color: ${({theme}) => theme.label.title};
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 28px;
  margin: 4px 0 ${({top}) => (top ? '1rem' : '0')};
  color: ${({theme}) => theme.label.description};
`;

const Optional = styled.span`
  color: ${({theme}) => theme.label.description};
  font-weight: 400;

  &::before {
    content: ' • ';
    color: ${({theme}) => theme.label.optionalDot};
  }
`;

const Label = ({
  title, description, children, optional, overflow, descriptionAtTop = false, ...props
}) => (
  <Wrapper $overflow={overflow} {...props}>
    <Title>{title}{optional && (<Optional>Optional</Optional>)}</Title>
    {(description && descriptionAtTop) && <Description top>{description}</Description>}
    {children}
    {(description && !descriptionAtTop) && <Description>{description}</Description>}
  </Wrapper>
);

export default Label;

export const GridLabel = styled(Label)`
  grid-area: ${({area}) => area};
`;
